import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject, SecurityContext, type OnInit } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { UiPictureModule } from '@big-direkt/ui/picture';
import { IconBigMediumExternerLink, IconComponent } from '@big-direkt/utils/icons';
import { PictureModel, SanitizePipe } from '@big-direkt/utils/shared';
import { translateObjectSignal } from '@jsverse/transloco';
import { NgPopoverRef } from 'ng-overlay-container';
import { BadgeOverlayData } from '../../models/badge-overlay-data.model';
import { ModalFrameComponent } from '../modal-frame/modal-frame.component';

@Component({
    selector: 'big-ui-modal-badge',
    templateUrl: './modal-badge.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [A11yModule, IconComponent, ModalFrameComponent, SanitizePipe, UiLinkComponent, UiPictureModule],
})
export class ModalBadgeComponent implements OnInit {
    public readonly popoverRef = inject<NgPopoverRef<BadgeOverlayData>>(NgPopoverRef);

    public readonly linkIcon = IconBigMediumExternerLink;
    public readonly securityContext = SecurityContext.HTML;
    public readonly translate = translateObjectSignal('uiModalBadge');

    public title?: string;
    public image?: PictureModel;
    public description!: string;
    public link?: {
        title: string;
        uri: string;
    };

    public ngOnInit(): void {
        const { name, description, image, link } = this.popoverRef.data;
        this.title = name;
        this.description = description;
        this.image = image;
        this.link = link;
    }
}
